import React, { useEffect, useState } from 'react';
import { Box, Typography, Link, useTheme, Container } from '@mui/material';
import Grid from './CustomGrid';
import logo from '../../assets/images/logo-tije.svg';
import ScrollToTop from "./ScrollToTop";
import { getFooterData } from "../../services/global";
import Preloader from './Preloader';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';

const Footer = () => {

  const theme = useTheme();
  const [footerData, setFooterData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const [footerResponse,] = await Promise.all([
          getFooterData(),
        ]);

        setFooterData(footerResponse || {});
      } catch (error) {
        console.error("Error fetching data:", error.response || error.message);
        setError(
          "Hubo un problema al cargar los datos del pie de página. Por favor, intenta nuevamente más tarde."
        );
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <Preloader />;
  }

  if (error) {
    return (
      <Box
        sx={{
          backgroundColor: "#E2E7F3",
          py: 6,
          px: { xs: 2, md: 8 },
          textAlign: "center",
        }}
      >
        <Typography variant="h6" sx={{ color: "error.main", mb: 2 }}>
          Error
        </Typography>
        <Typography variant="body1" sx={{ color: "text.secondary" }}>
          {error}
        </Typography>
      </Box>
    );
  }

  const SocialLinks = ({ socialLinks }) => {

    //console.log('socialLinks', socialLinks)

    if (!socialLinks || socialLinks.length === 0) {
      console.error("No se encontraron redes sociales.");
      return null;
    }

    const getIcon = (platform) => {
      switch (platform/* .toLowerCase() */) {
        case "LinkedIn":
          return <LinkedInIcon sx={{ color: "#0056f7", fontSize: "1.5rem", mr: 1 }} />;
        case "YouTube":
          return <YouTubeIcon sx={{ color: "#FF0000", fontSize: "1.5rem", mr: 1 }} />;
        /* case "facebook":
          return <FacebookIcon sx={{ color: "#4267B2", fontSize: "1.5rem", mr: 1 }} />;
        case "twitter":
          return <TwitterIcon sx={{ color: "#1DA1F2", fontSize: "1.5rem", mr: 1 }} />; */
        default:
          return null;
      }
    };

    return (
      <div>
        {socialLinks.map((social, index) => (
          <Link
            key={index}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ display: "flex", alignItems: "center", mb: 1 }}
          >
            {getIcon(social.platform)}
            {social.platform}
          </Link>
        ))}
      </div>
    );
  };



  const {
    title,
    description,
    email,
    phone_argentina,
    phone_spain,
    address,
    social_links
  } = footerData;

  return (
    <Box sx={{ backgroundColor: '#E2E7F3', py: 6, px: { xs: 2, md: 8 }, }} >
      <Container maxWidth="lg">
        <Grid container spacing={1}>
          <Grid size={{ xs: 12, md: 6 }}>
            <Typography variant="h3" sx={{
              color: 'primary.main', mb: 1,
              fontSize: { xs: theme.typography.pxToRem(24), md: theme.typography.pxToRem(36), }
            }}>
              {title}
            </Typography>
            <Typography variant="body1" sx={{ color: 'text.primary', mb: 2, fontWeight: 'bold' }}>
              {description}
            </Typography>

            <Grid container spacing={1}>

              <Grid size={{ xs: 12, md: 6 }}>
                <Typography variant="subtitle1" sx={{ color: 'primary.main', mb: 1, fontWeight: 'bold' }}>
                  Argentina
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.primary' }}>
                  <Link href={`tel:${phone_argentina}`} sx={{ color: 'inherit', textDecoration: 'none' }} >
                    {phone_argentina}
                  </Link>
                </Typography>
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <Typography variant="subtitle1" sx={{ color: 'primary.main', mb: 1, fontWeight: 'bold' }}>
                  España
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.primary' }}>
                  <Link href={`tel:${phone_spain}`} sx={{ color: 'inherit', textDecoration: 'none' }} >
                    {phone_spain}
                  </Link>
                </Typography>
              </Grid>

              <Grid size={{ xs: 12 }}>
                <Typography variant="subtitle1" sx={{ color: 'primary.main', mb: 1, fontWeight: 'bold' }}>
                  Dirección
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.primary' }}>
                  {address}
                </Typography>
              </Grid>
            </Grid>

          </Grid>

          <Grid size={{ xs: 12, md: 3 }}>
            <Typography variant="subtitle1" sx={{ color: 'primary.main', mt: 2, mb: 1, fontWeight: 'bold' }}>
              Email
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.primary', mb: 2 }}>
              <Link href={`mailto:${email}`} sx={{ color: 'inherit', textDecoration: 'none' }} >
                {email}
              </Link>
            </Typography>
            <Typography variant="subtitle1" sx={{ color: 'primary.main', mt: { xs: 2, md: 6 }, mb: 1, fontWeight: 'bold' }}>
              Redes
            </Typography>
            {/* <Link href="https://linkedin.com/company/e2etravelsolutions" target="_blank" sx={{ display: 'flex', alignItems: 'center' }}>
              <LinkedInIcon sx={{ color: '#0056f7', fontSize: '1.5rem', mr: 1 }} />
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                LinkedIn
              </Typography>
            </Link> */}
            <SocialLinks socialLinks={social_links} />
          </Grid>

          <Grid size={{ xs: 12, md: 3 }}>
            <img src={logo} alt="Logo TIje Travel" style={{}} />
          </Grid>
        </Grid>
      </Container>
      <ScrollToTop />
    </Box>
  );
};

export default Footer;
